import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const QuickCompaign = () => {
  return (
    <Box sx={{ height: "100%" }}>
      <Outlet />
    </Box>
  );
};

export default QuickCompaign;
